// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3qUKH","options":"AnswerScale_options__3OCkM","selected":"AnswerScale_selected__2_ABY"};